module.exports = __webpack_public_path__ + "img/equipment-07@2x.2b5feb64.png";